<template>
  <section class="benefits" id="card">
    <img class="paw paw-top-right" src="../assets/IMG/huella.png" alt="" aria-hidden="true" />
    <img class="paw paw-left" src="../assets/IMG/huella.png" alt="" aria-hidden="true" />
    <img class="paw paw-right" src="../assets/IMG/huella.png" alt="" aria-hidden="true" />

    <div class="benefits-content">
      <h1 class="main-title">NUESTROS BENEFICIOS</h1>

      <div class="features-container">
        <article class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/Beneficio1.png" alt="Acceso inmediato" />
          </div>
          <h2 class="feature-title">ACCESO INMEDIATO</h2>
          <p class="feature-text">
            En caso de emergencia, cualquier persona puede acceder rápidamente a su información médica y datos de contacto tu mascota.
          </p>
        </article>

        <article class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/Beneficio2.png" alt="Tecnología NFC, QR y GPS" />
          </div>
          <h2 class="feature-title">TECNOLOGÍA NFC, QR Y GPS</h2>
          <p class="feature-text">
            Integra NFC y código QR para escaneo inmediato desde cualquier smartphone, además de sistema GPS para facilitar su localización.
          </p>
        </article>

        <article class="feature-card">
          <div class="feature-image">
            <img src="../assets/IMG/Beneficio3.png" alt="Cómoda y resistente" />
          </div>
          <h2 class="feature-title">CÓMODA Y RESISTENTE</h2>
          <p class="feature-text">
            Diseñada para el uso diario, ligera y adaptable. No estorba, no incomoda y soporta la actividad normal de tu mascota.
          </p>
        </article>
      </div>
    </div>

    <div class="benefits-bones" aria-hidden="true">
      <i v-for="n in 22" :key="`benefit-bone-${n}`" class="fi fi-sr-bone benefits-bone-icon"></i>
    </div>
  </section>
</template>

<script>
export default {
  name: "Card",
  props: {},
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.benefits {
  background-color: #efefe4;
  display: flex;
  justify-content: center;
  padding: 70px 20px 112px;
  position: relative;
  overflow: hidden;
  scroll-margin-top: 95px;
}

.paw {
  position: absolute;
  width: 150px;
  opacity: 1;
  pointer-events: none;
}

.paw-top-right {
  top: 24px;
  right: 32px;
  width: 210px;
  transform: rotate(300deg);
}

.paw-left {
  left: 120px;
  top: 46%;
  width: 280px;
  transform: translateY(-50%) rotate(-70deg);
}

.paw-right {
  right: -85px;
  top: 34%;
  width: 210px;
  transform: rotate(300deg);
}

.benefits-content {
  width: 100%;
  max-width: 1260px;
  position: relative;
  z-index: 1;
  transform: translateY(-10px);
}

.benefits-bones {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  gap: clamp(14px, 1.5vw, 24px);
  white-space: nowrap;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  opacity: 0.6;
  transform: translateY(3px);
}

.benefits-bone-icon {
  color: #9bb9df;
  font-size: clamp(64px, 5.6vw, 88px);
  line-height: 1;
  flex: 0 0 auto;
  display: inline-block;
  transform: rotate(45deg) scaleX(1);
  transform-origin: center;
}

.main-title {
  font-family: "Barlow", sans-serif;
  font-size: clamp(2.4rem, 5vw, 4.6rem);
  font-weight: 700;
  color: #1f67b6;
  margin: 0;
  line-height: 1.1;
  max-width: 460px;
  margin-bottom: 44px;
}

.features-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 34px;
  justify-items: center;
}

.feature-card {
  text-align: center;
  max-width: 390px;
}

.feature-image {
  margin-bottom: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 198px;
  transition: transform 220ms ease;
}

.feature-card:nth-child(1) .feature-image {
  margin-top: 40px;
}

.feature-card:nth-child(2) .feature-image,
.feature-card:nth-child(3) .feature-image {
  height: 268px;
  margin-top: -28px;
}

.feature-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
  border-radius: 14px;
  transition: transform 220ms ease, box-shadow 220ms ease;
}

.feature-card:hover .feature-image img {
  transform: scale(1.035);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}

.feature-title {
  font-family: "Barlow", sans-serif;
  font-size: clamp(2rem, 3.1vw, 2.8rem);
  font-weight: 700;
  color: #1f67b6;
  margin: 14px 0 14px;
  line-height: 0.95;
}

.feature-text {
  font-family: "Barlow", sans-serif;
  font-size: clamp(1.08rem, 1.5vw, 1.24rem);
  color: #222;
  font-weight: 400;
  line-height: 1.35;
  margin: 0;
}

@media (max-width: 1024px) {
  .benefits {
    padding: 56px 20px 102px;
  }

  .main-title {
    margin-bottom: 34px;
  }

  .paw-top-right,
  .paw-right {
    width: 165px;
  }

  .features-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .feature-card:nth-child(3) {
    grid-column: 1 / -1;
    max-width: 500px;
  }

  .feature-image {
    height: 224px;
  }

  .feature-card:nth-child(1) .feature-image {
    margin-top: 36px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 268px;
    margin-top: -24px;
  }

  .feature-title {
    font-size: clamp(1.8rem, 3.4vw, 2.5rem);
  }
}

@media (max-width: 768px) {
  .benefits {
    padding: 48px 16px 92px;
  }

  .main-title {
    font-size: clamp(2rem, 10vw, 3.3rem);
    margin-bottom: 28px;
    max-width: 320px;
  }

  .paw {
    width: 100px;
  }

  .paw-top-right,
  .paw-right {
    width: 125px;
  }

  .paw-left,
  .paw-right {
    opacity: 1;
  }

  .features-container {
    grid-template-columns: 1fr;
    gap: 38px;
  }

  .feature-card,
  .feature-card:nth-child(3) {
    max-width: 430px;
  }

  .feature-image {
    height: 214px;
  }

  .feature-card:nth-child(1) .feature-image {
    margin-top: 18px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 260px;
    margin-top: -20px;
  }
}

@media (max-width: 480px) {
  .benefits {
    padding: 42px 14px 86px;
  }

  .benefits-bones {
    bottom: 0;
    gap: 12px;
    opacity: 0.55;
    transform: translateY(-4px);
  }

  .benefits-bone-icon {
    font-size: 58px;
  }

  .feature-image {
    height: 186px;
  }

  .feature-card:nth-child(2) .feature-image,
  .feature-card:nth-child(3) .feature-image {
    height: 224px;
    margin-top: -16px;
  }

  .feature-title {
    font-size: clamp(1.7rem, 8vw, 2.1rem);
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .feature-text {
    font-size: 1.1rem;
  }
}
</style>
